import { useEffect } from 'react';
import UserAPI from 'services/API/UserAPI';
import { useRefetchingUserAtom, useUsersAtom } from 'state/auth';

const useOrganizationUsers = () => {
  const [organizationUsers, setOrganizationUsers] = useUsersAtom();
  const [refetchingUsers, setRefetchingUser] = useRefetchingUserAtom();

  const fetchOrganizationUsers = async () => {
    setRefetchingUser(true);
    const response = await UserAPI.getOrganizationUsers();
    setOrganizationUsers(response.data.data);
    setRefetchingUser(false);
  };

  useEffect(() => {
    fetchOrganizationUsers();
  }, []);

  return {
    organizationUsers,
    refetchingUsers,
    fetchOrganizationUsers,
  };
};

export default useOrganizationUsers;
